import { render, staticRenderFns } from "./r-checkbox.vue?vue&type=template&id=5301e618&scoped=true&"
import script from "./r-checkbox.vue?vue&type=script&lang=js&"
export * from "./r-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./r-checkbox.vue?vue&type=style&index=0&id=5301e618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301e618",
  null
  
)

export default component.exports